var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    { attrs: { cols: "12" } },
    [
      _c(
        "base-card",
        [
          _c("v-card-title", [
            _vm._v(" Generador de informe de documentos pendientes "),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-form",
                { ref: "form" },
                [
                  _c(
                    "v-row",
                    [
                      _c("v-col", { attrs: { cols: "12" } }, [
                        _vm._v(
                          " El informe solo podrá generarse dentro de un rango de 90 días. "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "4" } },
                        [
                          _c(
                            "v-dialog",
                            {
                              ref: "dialog",
                              attrs: { persistent: "", width: "300px" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-text-field",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: {
                                                label: "Rango de fechas",
                                                "prepend-icon": "mdi-calendar",
                                                readonly: "",
                                                required: "",
                                                error: _vm.dateRangeError,
                                                "error-messages":
                                                  _vm.dateRangeErrorMessage,
                                                rules: [
                                                  (v) =>
                                                    !!v ||
                                                    "Este campo es obligatorio",
                                                ],
                                              },
                                              model: {
                                                value:
                                                  _vm.processedDocsData
                                                    .dateRange,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.processedDocsData,
                                                    "dateRange",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "processedDocsData.dateRange",
                                              },
                                            },
                                            "v-text-field",
                                            attrs,
                                            false
                                          ),
                                          on
                                        )
                                      ),
                                    ]
                                  },
                                },
                              ]),
                              model: {
                                value: _vm.modal,
                                callback: function ($$v) {
                                  _vm.modal = $$v
                                },
                                expression: "modal",
                              },
                            },
                            [
                              _c(
                                "v-date-picker",
                                {
                                  attrs: {
                                    range: "",
                                    min: _vm.minDate,
                                    max: _vm.maxDate,
                                    "disabled-dates": _vm.disabledDates,
                                  },
                                  on: { input: _vm.onDateRangeInput },
                                  model: {
                                    value: _vm.processedDocsData.dateRange,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.processedDocsData,
                                        "dateRange",
                                        $$v
                                      )
                                    },
                                    expression: "processedDocsData.dateRange",
                                  },
                                },
                                [
                                  _c("v-spacer"),
                                  _c(
                                    "v-btn",
                                    {
                                      staticStyle: {
                                        "background-color": "rgb(204 33 40)",
                                        color: "white !important",
                                      },
                                      attrs: { text: "" },
                                      on: {
                                        click: function ($event) {
                                          _vm.modal = false
                                        },
                                      },
                                    },
                                    [_vm._v(" Cancel ")]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      staticStyle: {
                                        "background-color": "rgb(204 33 40)",
                                        color: "white !important",
                                      },
                                      attrs: { text: "" },
                                      on: { click: _vm.onAccept },
                                    },
                                    [_vm._v(" OK ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "4" } },
                        [
                          _c("v-text-field", {
                            ref: "Nit",
                            attrs: {
                              label: "Correo",
                              counter: "",
                              maxlength: "80",
                              "prepend-inner-icon": "mdi-email",
                              required: "",
                              rules: [
                                (v) => !!v || "Este campo es obligatorio",
                                (v) =>
                                  /.+@.+\..+/.test(v) ||
                                  "El correo no es válido",
                              ],
                            },
                            model: {
                              value: _vm.processedDocsData.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.processedDocsData, "email", $$v)
                              },
                              expression: "processedDocsData.email",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("v-col", { attrs: { cols: "12", sm: "1" } }),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "3" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "ma-2",
                              style: _vm.generateButtonStyle,
                              attrs: { disabled: _vm.generatingReport },
                              on: { click: _vm.validateForm },
                            },
                            [_vm._v(" Generar ")]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "ma-2",
                              attrs: {
                                color: "GRAY",
                                disabled: _vm.generatingReport,
                              },
                              on: { click: _vm.clearForm },
                            },
                            [_vm._v(" Limpiar ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-alert",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.successAlert,
                                  expression: "successAlert",
                                },
                              ],
                              attrs: { type: "success", text: "" },
                            },
                            [_vm._v(" " + _vm._s(_vm.successAlertMsg) + " ")]
                          ),
                          _c(
                            "v-alert",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errorAlert,
                                  expression: "errorAlert",
                                },
                              ],
                              attrs: { type: "warning", text: "" },
                            },
                            [_vm._v(" " + _vm._s(_vm.errorAlertMsg) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }